import { useQuery } from '@tanstack/react-query'
import { getAllNotifications } from '../services/Notifications'
import { TAGS } from '../services/Tags'
import { OUT_OF_THE_APP } from '../utils/constants'

export const useGetAllNotifications = ({ page = 0 } = {}) => {
  const {
    data = {},
    isLoading,
    isError,
  } = useQuery([TAGS.all_notifications, page], () => getAllNotifications({ page }), {
    enabled: !OUT_OF_THE_APP,
    staleTime: Infinity, // Los datos NUNCA se consideran obsoletos
    gcTime: Infinity, // Mantener en cache indefinidamente
    refetchOnMount: false, // NO refetch al montar componentes
    refetchOnWindowFocus: false, // NO refetch al enfocar la ventana
    refetchOnReconnect: false, // NO refetch al reconectar
  })

  return { data, isLoading, isError }
}
